import React, { useEffect } from 'react';

export function CareersJoin() {
  useEffect(() => {
    const container = document.getElementById('clearcompany-careers');
    if (!container) return;

    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src = 'https://careers-content.clearcompany.com/js/v1/career-site.js?siteId=775e6187-14d1-6af1-7a45-faae3a51dd90';
    container.appendChild(script);
  }, []);

  return (
    <section className="expert-bg d-flex align-items-center pt-5 mb-5 hr-divider hr-divider-consult" id="open-positions">
      <div className="container section-width pt-3" id="clearcompany-careers" />
    </section>
  );
}

export default CareersJoin;
